<template>
  <div class="recycler-map">
    <!-- 左侧筛选列表 -->
    <div class="tab" v-if="tabShow">
      <div class="tab_top">
        <div class="flexCB tab_top_title">
          <div class="flexCS tab_top_title_left">
            <div class="tab_top_title_icon"></div>
            <div>智能回收机列表</div>
          </div>
          <div class="tab_top_title_right" @click="tabShowChange"></div>
        </div>
        <!-- 仅保留状态筛选栏 -->
        <div class="flexWCA tab_top_allStatusBtn" style="margin-top: 15px;">
          <div
            :class="[
              'tab_top_allStatusBtn_item',
              item.value == deviceStatus ? 'btn_active' : '',
            ]"
            v-for="item in deviceTab"
            :key="item.value"
            @click="checkedStatusHandler(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="tab_bot">
        <div class="tab_bot_title" @click="dataListHandler()">
          <span style="color: #000; margin-right: 5px" v-if="dataListShow">∨</span>
          <span style="color: #000; margin-right: 5px" v-else>∧</span>
          回收机列表({{ dataList.length }})
        </div>
        <el-collapse-transition>
          <div v-if="dataListShow">
            <div class="flexCB tab_bot_informationBar">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >设备名称</el-checkbox
              >
              <div style="margin-right: 15px">操作</div>
            </div>
            <div class="tab_bot_list">
              <el-checkbox-group
                v-model="checkedCities"
                @change="handleCheckedCitiesChange"
              >
              <el-checkbox
                v-for="(item, index) in dataList"
                :label="item.id"
                :key="item.id"
                :data-device-no="item.deviceNo" 
              >
                <div class="flexCB tab_bot_list_checkbox">
                  <div>{{ item.deviceName }}</div>
                  <div class="flexCS tab_bot_list_information">
                    <div class="tab_bot_list_information_run" @click="redirectDetail(item.id)" data-tip="设备详情">
                      详情
                    </div>
                  </div>
                </div>
              </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
    <!-- 侧边收起按钮 -->
    <div class="tab" style="width: 30px" v-else>
      <div
        style="
          border: 8px solid;
          border-color: transparent transparent transparent #1aa689;
        "
        @click="tabShowChange()"
      ></div>
    </div>
    <!-- 高德地图容器 -->
    <div id="container" class="map-container">
      <!-- 标记点加载提示 -->
      <div class="map-loading" v-if="loadingMarker">
        加载标记点中...
      </div>
    </div>
  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import _ from 'lodash';
// 高德地图安全密钥
window._AMapSecurityConfig = {
  securityJsCode: "8e9c248f99df3ed6ea243177e37306d1",
};

import { getWlRecycleDeviceList, getStreet, getCommunity } from "@/api/recyclingMachine";
let AMap = null;
let mapInstance = null;
var markers = []; // 地图标记点数组
var infoWindow = null; // 信息弹窗
var infoWindowDeviceNo = null; // 当前弹窗的设备编号
// 新增：防重复触发锁
let isHandlingCheckChange = false;

export default {
  name: "RecyclerMapPage",
  data() {
    return {
      allDeviceList: [], // 全量设备列表（用于统计状态）
      dataList: [], // 筛选后的设备列表
      checkAll: false, // 全选状态
      checkedCities: [], // 选中的设备ID
      isIndeterminate: false, // 半选状态
      dataSet: new Set(), // 已加载的设备编号集合
      dataListShow: true, // 列表展开/收起
      deviceTab: [], // 设备状态标签（自行统计生成）
      deviceStatus: 0, // 默认选中全部状态
      tabShow: true, // 左侧面板显示/隐藏
      communityNameArr: [], // 街道列表
      communityResAll: [], // 社区列表
      picUrls: [
        'https://waliminiapp.oss-cn-beijing.aliyuncs.com/recycleDevice/2.png',
        'https://waliminiapp.oss-cn-beijing.aliyuncs.com/recycleDevice/2.png',
        'https://waliminiapp.oss-cn-beijing.aliyuncs.com/recycleDevice/2.png',
        'https://waliminiapp.oss-cn-beijing.aliyuncs.com/recycleDevice/3.png',
        'https://waliminiapp.oss-cn-beijing.aliyuncs.com/recycleDevice/4.png',
        'https://waliminiapp.oss-cn-beijing.aliyuncs.com/recycleDevice/5.png',
        'https://waliminiapp.oss-cn-beijing.aliyuncs.com/recycleDevice/6.png',
        'https://waliminiapp.oss-cn-beijing.aliyuncs.com/recycleDevice/7.png',
        'https://waliminiapp.oss-cn-beijing.aliyuncs.com/recycleDevice/8.png',
        'https://waliminiapp.oss-cn-beijing.aliyuncs.com/recycleDevice/8.png',
        'https://waliminiapp.oss-cn-beijing.aliyuncs.com/recycleDevice/10.png'
      ],
      // 预加载图标缓存（解决动态图标不显示问题）
      iconCache: {},
      iconLoadPromise: null,
      lastSelectedDeviceNo: '', // 最后一个选中的设备编号
      loadingMarker: false // 标记点加载状态
    };
  },
  methods: {
    /**
     * 预加载图标图片（解决动态图标不显示问题）
     */
    preloadIcons() {
      const iconPromises = this.picUrls.map((url) => {
        return new Promise((resolve) => {
          if (this.iconCache[url]) {
            resolve(url);
            return;
          }
          const img = new Image();
          img.crossOrigin = "anonymous"; // 解决跨域加载问题
          img.src = url;
          img.onload = () => {
            this.iconCache[url] = img;
            console.log(`图标加载成功: ${url}`);
            resolve(url);
          };
          img.onerror = (err) => {
            console.error(`图标加载失败: ${url}`, err);
            // 加载失败时使用默认图标兜底
            this.iconCache[url] = this.iconCache[this.picUrls[0]] || new Image();
            resolve(url);
          };
        });
      });
      this.iconLoadPromise = Promise.all(iconPromises);
    },
    /**
     * 从全量列表筛选数据（仅按状态筛选）
     */
    filterDeviceList() {
      let filteredList = [...this.allDeviceList];

      // 仅按设备状态过滤（0=全部）
      if (this.deviceStatus !== 0) {
        filteredList = filteredList.filter(item => Number(item.deviceStatus) === this.deviceStatus);
      }

      // 处理筛选后列表
      this.dataList = filteredList.map((item, index) => ({
        ...item,
        id: item.id, // 使用接口返回的真实ID
      }));

      // 清空旧标记点（修复：先判断mapInstance是否存在）
      if (mapInstance && markers.length) {
        mapInstance.remove(markers);
        markers = [];
      }
      this.dataSet.clear();
      this.lastSelectedDeviceNo = ''; // 重置最后选中设备

      // 重置选中状态
      this.checkAll = false;
      this.checkedCities = [];
      this.isIndeterminate = false;
    },
    /**
     * 统计设备状态数量（仅按全量列表统计）
     */
    statDeviceStatus() {
      // 固定状态映射：0-全部 1-隐藏 2-离线 3-在线 4-故障
      const statusMap = {
        0: { label: '全部', count: 0 },
        1: { label: '隐藏', count: 0 },
        2: { label: '离线', count: 0 },
        3: { label: '在线', count: 0 },
        4: { label: '故障', count: 0 },
      };

      // 统计全量列表各状态数量
      this.allDeviceList.forEach(item => {
        const status = Number(item.deviceStatus) || 0;
        // 仅统计1-4的有效状态
        if (status >= 1 && status <= 4) {
          statusMap[status].count++;
          statusMap[0].count++; // 全部数量累加
        }
      });

      // 生成状态标签
      this.deviceTab = [
        { label: `${statusMap[0].label} (${statusMap[0].count})`, value: 0 },
        { label: `${statusMap[1].label} (${statusMap[1].count})`, value: 1 },
        { label: `${statusMap[2].label} (${statusMap[2].count})`, value: 2 },
        { label: `${statusMap[3].label} (${statusMap[3].count})`, value: 3 },
        { label: `${statusMap[4].label} (${statusMap[4].count})`, value: 4 },
      ];
    },
    /**
     * 获取全量设备列表
     */
    async getRecyclerList() {
      try {
        const res = await getWlRecycleDeviceList({
          pageSize: 9999,
          pageNo: 1
        });

        if (res.code !== 200) {
          this.$message.warning(res.msg);
          return;
        }

        // 保存全量列表并处理关联数据
        this.allDeviceList = (res.data.records || res.data.list || []).map(item => {
          // 匹配社区名称
          let communityName = '';
          if (!_.isEmpty(this.communityResAll)) {
            const community = this.communityResAll.find(comm => comm.id === _.toNumber(_.get(item, 'wlCommunityId')));
            communityName = community ? community.name : '';
          }

          // 匹配街道名称
          let streetName = '';
          if (!_.isEmpty(this.communityNameArr)) {
            const street = this.communityNameArr.find(str => str.id === _.toNumber(_.get(item, 'wlStreetId')));
            streetName = street ? street.name : '';
          }

          // 处理容量对应的图标
          let picUrl = this.picUrls[0]; // 默认图标
          if (item.usedCapacity !== undefined && item.usedCapacity !== null) {
            const capacityNum = _.toNumber(item.usedCapacity);
            // 确保不越界
            picUrl = this.picUrls[Math.min(capacityNum, this.picUrls.length - 1)] || this.picUrls[0];
          }

          return {
            ...item,
            communityName,
            streetName,
            communityNameAll: `${communityName}${streetName}`,
            picUrl
          };
        });

        // 预加载所有设备图标
        this.preloadIcons();

        // 统计状态并生成标签
        this.statDeviceStatus();
        // 筛选列表
        this.filterDeviceList();
      } catch (error) {
        console.error("获取回收机列表失败：", error);
        this.$message.error("数据加载失败，请重试");
      }
    },
    /**
     * 切换设备状态筛选
     */
    checkedStatusHandler(val) {
      if (this.deviceStatus === val) return;
      this.deviceStatus = val;
      this.isIndeterminate = false;
      this.checkAll = false;
      this.checkedCities = []; // 重置选中状态
      this.lastSelectedDeviceNo = ''; // 重置最后选中设备
      this.filterDeviceList(); // 重新筛选列表
    },
    /**
     * 全选/取消全选
     */
    handleCheckAllChange(val) {
      // 防重复触发
      if (isHandlingCheckChange) return;
      isHandlingCheckChange = true;
      
      this.checkedCities = val ? this.dataList.map(item => item.id) : [];
      // 触发选中变化逻辑
      this.handleCheckedCitiesChange(this.checkedCities);
      
      // 释放锁
      setTimeout(() => {
        isHandlingCheckChange = false;
      }, 100);
    },
    /**
     * 多选设备变化（核心：防重复触发+消除递归）
     */
    handleCheckedCitiesChange(value) {
      // 1. 防重复触发锁
      if (isHandlingCheckChange || !mapInstance || !AMap) return;
      isHandlingCheckChange = true;

      try {
        // 标记加载状态
        this.loadingMarker = true;

        // 深拷贝避免响应式触发重复更新
        const checkedValues = [...value];
        const checkedCount = checkedValues.length;

        // 更新全选/半选状态
        this.checkAll = checkedCount === this.dataList.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.dataList.length;

        // 1. 先隐藏所有标记点
        markers.forEach(marker => {
          try {
            marker.hide();
          } catch (e) {
            console.warn('隐藏标记点失败:', e);
          }
        });
        // 关闭旧弹窗
        infoWindow?.close();

        // 2. 处理选中的设备
        if (checkedCount > 0) {
          // 记录最后一个选中的设备ID（仅取一次，避免循环）
          const lastSelectedId = checkedValues[checkedValues.length - 1];
          const lastDevice = this.dataList.find(item => item.id === lastSelectedId);
          if (!lastDevice) return;

          this.lastSelectedDeviceNo = lastDevice.deviceNo;

          // 遍历加载所有选中设备的标记点（同步执行）
          const loadTasks = [];
          checkedValues.forEach(deviceId => {
            const item = this.dataList.find(i => i.id === deviceId);
            if (!item) return;

            const marker = markers.find(m => m?._opts?.deviceNo === item.deviceNo);
            if (marker) {
              // 显示已存在的标记点
              marker.show();
              marker.setzIndex(999);
            } else {
              // 收集加载任务，避免嵌套异步
              loadTasks.push(this.loadMarkerSync(item.deviceNo));
            }
          });

          // 批量加载完成后显示弹窗（仅执行一次）
          Promise.all(loadTasks).then(() => {
            // 直接渲染弹窗，不再递归调用自身
            this.renderLastSelectedWindow();
          });
        } else {
          // 无选中设备时重置
          this.lastSelectedDeviceNo = '';
        }
      } catch (error) {
        console.error('加载标记点失败:', error);
      } finally {
        // 结束加载状态 + 释放锁（延迟避免重复触发）
        setTimeout(() => {
          this.loadingMarker = false;
          isHandlingCheckChange = false;
        }, 200);
      }
    },
    /**
     * 同步加载标记点（仅创建，不递归）
     */
    loadMarkerSync(deviceNo) {
      return new Promise((resolve) => {
        const currentMarker = markers.find(item => item?._opts?.deviceNo === deviceNo);
        if (currentMarker) {
          currentMarker.show();
          resolve();
          return;
        }

        this.dataSet.add(deviceNo);
        const deviceInfo = this.allDeviceList.find(item => item.deviceNo === deviceNo);
        if (!deviceInfo || !deviceInfo.longitude || !deviceInfo.latitude) {
          resolve();
          return;
        }

        const lng = Number(deviceInfo.longitude);
        const lat = Number(deviceInfo.latitude);

        // 验证经纬度范围
        if (lng < -180 || lng > 180 || lat < -90 || lat > 90) {
          console.warn(`设备${deviceNo}经纬度无效：${lng},${lat}`);
          resolve();
          return;
        }

        // GPS坐标转换（同步处理）
        AMap.convertFrom(
          [lng, lat],
          "gps",
          (convertResult) => {
            let finalLnglat = [lng, lat];
            if (convertResult && convertResult.info === 'ok' && convertResult.locations && convertResult.locations.length > 0) {
              finalLnglat = [convertResult.locations[0].lng, convertResult.locations[0].lat];
            }

            // 创建标记点（无递归）
            this.createMarkerSync(deviceInfo, finalLnglat, resolve);
          }
        );
      });
    },
    /**
     * 同步创建标记点（无递归回调）
     */
    createMarkerSync(deviceInfo, lnglat, resolve) {
      try {
        const iconUrl = deviceInfo.picUrl || this.picUrls[0];
        const deviceIcon = new AMap.Icon({
          size: new AMap.Size(18, 26),
          imageSize: new AMap.Size(18, 26),
          image: iconUrl,
        });

        const marker = new AMap.Marker({
          position: new AMap.LngLat(lnglat[0], lnglat[1]),
          icon: deviceIcon,
          offset: new AMap.Pixel(-8, -75),
          renderMode: 'css',
          animation: 'AMAP_ANIMATION_DROP',
          deviceNo: deviceInfo.deviceNo
        });

        // 标记点点击事件：防重复触发
        marker.on('click', () => {
          if (isHandlingCheckChange) return;
          isHandlingCheckChange = true;

          const targetDevice = this.dataList.find(item => item.deviceNo === deviceInfo.deviceNo);
          if (targetDevice) {
            // 避免重复push导致数组变化触发监听
            const newChecked = [...this.checkedCities];
            if (!newChecked.includes(targetDevice.id)) {
              newChecked.push(targetDevice.id);
              this.checkedCities = newChecked;
            }
            // 直接更新最后选中并渲染弹窗
            this.lastSelectedDeviceNo = deviceInfo.deviceNo;
            this.renderLastSelectedWindow();
          }

          // 释放锁
          setTimeout(() => {
            isHandlingCheckChange = false;
          }, 100);
        });

        // 去重并添加标记点
        markers = markers.filter(item => item?._opts?.deviceNo !== deviceInfo.deviceNo);
        markers.push(marker);
        mapInstance.add(marker);
        marker.show();
        marker.setzIndex(999);

        // 调整视野（仅一次）
        mapInstance.setFitView(markers.filter(m => m));

        // 执行回调，标记创建完成
        resolve();
      } catch (error) {
        console.error(`创建标记点失败（设备${deviceInfo?.deviceNo}）：`, error);
        resolve();
      }
    },
    /**
     * 直接渲染最后选中设备弹窗（无递归）
     */
    renderLastSelectedWindow() {
      if (!mapInstance || !this.lastSelectedDeviceNo) return;

      // 找到最后选中设备信息
      const deviceInfo = this.allDeviceList.find(item => item.deviceNo === this.lastSelectedDeviceNo);
      if (!deviceInfo || !deviceInfo.longitude || !deviceInfo.latitude) return;

      const lng = Number(deviceInfo.longitude);
      const lat = Number(deviceInfo.latitude);
      const lnglat = [lng, lat];

      // 找到或创建标记点
      let lastMarker = markers.find(m => m?._opts?.deviceNo === this.lastSelectedDeviceNo);
      if (!lastMarker) {
        // 直接创建，不递归
        this.createMarkerSync(deviceInfo, lnglat, () => {
          lastMarker = markers.find(m => m?._opts?.deviceNo === this.lastSelectedDeviceNo);
          if (lastMarker) lastMarker.setzIndex(1000);
        });
      } else {
        // 标记点置顶
        markers.forEach(m => {
          try {
            m.setzIndex(999);
          } catch (e) {
            console.warn('设置标记点层级失败:', e);
          }
        });
        lastMarker.setzIndex(1000);
      }

      // 直接渲染弹窗
      this.renderInfoWindow(lastMarker, deviceInfo, deviceInfo.address || '未知地址', lnglat);
      mapInstance.setCenter(lnglat);
      mapInstance.setZoom(15);
    },
    /**
     * 初始化高德地图（确保DOM加载完成）
     */
    async initMap() {
      if (mapInstance) return mapInstance;

      // 确保容器DOM已渲染
      await this.$nextTick();

      return AMapLoader.load({
        key: "c98add164435e1dd4beff2d292a4fffb", // 高德地图Key
        version: "2.0",
        plugins: ["AMap.convertFrom", "AMap.InfoWindow"],
      })
        .then((aMap) => {
          AMap = aMap; // 确保AMap全局赋值
          // 创建地图实例
          mapInstance = new AMap.Map("container", {
            zoom: 13.4, // 初始缩放级别
            center: [116.532645, 40.101266], // 初始中心点
            mapStyle: "amap://styles/66382f6340493a41e17e609d48df5b08", // 自定义地图样式
            resizeEnable: true,
            layers: [new AMap.TileLayer()],
            zIndex: 100
          });

          console.log("地图初始化成功");
          return mapInstance;
        })
        .catch((e) => {
          console.error("地图初始化失败：", e);
          this.$message.error("地图加载失败，请刷新页面");
        });
    },
    /**
     * 渲染信息弹窗
     */
    renderInfoWindow(marker, deviceInfo, address, lnglat) {
      if (!mapInstance || !AMap) return;

      // 设备状态样式
      const statusMap = {
        1: { text: '隐藏', color: '#999' },
        2: { text: '离线', color: '#f56c6c' },
        3: { text: '在线', color: '#67c23a' },
        4: { text: '故障', color: '#e6a23c' }
      };
      const status = Number(deviceInfo.deviceStatus) || 0;
      const statusInfo = statusMap[status] || { text: '未知', color: '#666' };

      // 创建弹窗
      infoWindow = new AMap.InfoWindow({
        anchor: "top-center",
        offset: new AMap.Pixel(0, -50),
        content: `
            <div style="width: 380px; font-size: 12px; position: relative; overflow: hidden;">
              <div style="display: flex; justify-content: space-between; padding: 5px 8px; background-color: #fbfbfb;">
                <div>
                  <span>${deviceInfo.deviceNo}&nbsp</span>
                  <i class="el-icon-document-copy" onclick="copyDeviceNo('${deviceInfo.deviceNo}')" style="cursor: pointer;"></i>
                </div>
              </div>
              <div style="display: flex; justify-content: space-between; align-items: flex-start; padding: 5px 8px;">
                <div style="flex: 1;">
                  <div style="display: flex; margin-bottom: 4px;">
                    <div style="color: #666; width: 70px;">设备名称：</div>
                    <div style="color: #333;">${deviceInfo.deviceName || '-'}</div>
                  </div>
                  <div style="display: flex; margin-bottom: 4px;">
                    <div style="color: #666; width: 70px;">设备状态：</div>
                    <div style="color: ${statusInfo.color}; font-weight: 600;">${statusInfo.text}</div>
                  </div>
                  <div style="display: flex; margin-bottom: 4px;">
                    <div style="color: #666; width: 70px;">已用容量：</div>
                    <div style="color: #333;">${deviceInfo.usedCapacity || 0}/10</div>
                  </div>
                  <div style="display: flex; margin-bottom: 4px;">
                    <div style="color: #666; width: 70px;">社区：</div>
                    <div style="color: #333;">${deviceInfo.communityNameAll || '-'}</div>
                  </div>
                  <div style="display: flex; margin-bottom: 4px;">
                    <div style="color: #666; width: 70px;">创建时间：</div>
                    <div style="color: #333;">${deviceInfo.createTime || '-'}</div>
                  </div>
                </div>
                <div style="width: 60px; text-align: center; margin-left: 10px;">
                  <img src="${deviceInfo.picUrl || this.picUrls[0]}" alt="设备图标" style="width: 27px; height: 39px;">
                </div>
              </div>
              <div style="padding: 5px 8px; border-top: 1px solid #f0f0f0;">
                <span><img style="width: 10px; height: 10px; margin-right: 4px;" src="https://waliminiapp.oss-cn-beijing.aliyuncs.com/manage/gps/loaction.png" alt=""></span>
                <span style="color: #666;">${address}</span>
              </div>
              <div style="padding: 8px; display: flex; justify-content: space-around; border-top: 1px solid #f0f0f0;">
                <span onclick="redirectToDetail('${deviceInfo.id}')" style="cursor: pointer;">
                  <div style="font-size: 10px;">详情</div>
                </span>
              </div>
              <div style="position: absolute; bottom: -50px; left: 50%; transform: translateX(-50%); text-align: center;">
                <div style="width: 0;height: 0; border-top: 10px solid #fff; border-right: 10px solid transparent; border-bottom: 10px solid transparent; border-left: 10px solid transparent;"></div>
              </div>
            </div>
          `,
        zIndex: 1001
      });

      infoWindowDeviceNo = deviceInfo.deviceNo;
      try {
        infoWindow.open(mapInstance, lnglat);
      } catch (e) {
        console.warn('打开弹窗失败:', e);
      }
    },
    /**
     * 复制设备编号
     */
    copyDeviceNo(deviceNo) {
      const input = document.createElement("input");
      input.value = deviceNo;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message.success("设备编号复制成功");
    },
    /**
     * 展开/收起列表
     */
    dataListHandler() {
      this.dataListShow = !this.dataListShow;
    },
    /**
     * 显示/隐藏左侧面板
     */
    tabShowChange() {
      this.tabShow = !this.tabShow;
    },
    /**
     * 跳转设备详情页
     */
    redirectDetail(id) {
      this.$router.push({
        name: "智能回收机详情",
        params: { id: id }
      });
    },
  },
  watch: {
    // 监听选中设备变化（添加防抖+防重复）
    checkedCities: {
      handler: _.debounce(function(cur) {
        if (cur.length && mapInstance && !isHandlingCheckChange) {
          this.handleCheckedCitiesChange(cur);
        }
      }, 100),
      deep: true,
    },
  },
  async created() {
    try {
      this.preloadIcons();
      await this.initMap();
      const [streetRes, communityRes] = await Promise.all([
        getStreet(),
        getCommunity({})
      ]);
      this.communityNameArr = streetRes.data || [];
      this.communityResAll = communityRes.data || [];
      await this.getRecyclerList();
    } catch (error) {
      console.error("初始化失败：", error);
      this.$message.error("页面初始化失败，请刷新重试");
    }
  },
  mounted() {
    window.copyDeviceNo = this.copyDeviceNo;
    window.redirectToDetail = this.redirectDetail;

    window.addEventListener('resize', () => {
      if (mapInstance) {
        mapInstance.resize();
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {});

    if (mapInstance) {
      try {
        mapInstance.destroy();
      } catch (e) {
        console.warn('销毁地图失败:', e);
      }
      mapInstance = null;
    }
    markers = [];
    infoWindow = null;
    this.lastSelectedDeviceNo = '';
    this.loadingMarker = false;
    isHandlingCheckChange = false; // 重置锁
  },
};
</script>

<style scoped lang="less">
// 通用flex布局
.flex {
  display: flex;
}
.flexCB {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flexCS {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.flexWCA {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}

// 左侧面板
.recycler-map {
  position: relative;
  width: 100%;
  height: 100vh;

  .tab {
    width: 280px;
    height: 100%;
    background: #fff;
    padding: 15px 10px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;

    // 顶部筛选区
    .tab_top {
      .tab_top_title {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 12px;

        .tab_top_title_icon {
          background: #1aa689;
          width: 5px;
          height: 18px;
          margin-right: 10px;
          border-radius: 3px;
        }
        .tab_top_title_right {
          width: 0;
          height: 0;
          border: 8px solid;
          border-color: transparent #1aa689 transparent transparent;
          cursor: pointer;
        }
      }

      .tab_top_allStatusBtn {
        .tab_top_allStatusBtn_item {
          width: 48%;
          color: rgba(0, 0, 0, 0.85);
          font-size: 12px;
          text-align: center;
          line-height: 28px;
          border: 1px solid #d9d9d9;
          margin-top: 8px;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.2s;

          &:hover {
            color: #1aa689;
          }
        }
      }

      .btn_active {
        color: #fff !important;
        background: #1aa689;
        border: 1px solid #1aa689 !important;
      }
    }

    // 列表区
    .tab_bot {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 10px;

      .tab_bot_title {
        padding: 8px 0;
        border-bottom: 1px solid #e8e8e8;
        cursor: pointer;
        font-weight: 500;
      }

      .tab_bot_informationBar {
        padding: 8px 0;
        border-bottom: 1px solid #e8e8e8;

        /deep/.el-checkbox__label {
          font-size: 12px !important;
        }
      }

      .tab_bot_list {
        height: calc(100vh - 200px);
        margin-top: 8px;
        padding-right: 6px;
        overflow: auto;
        padding-bottom: 60px;

        /deep/.el-checkbox {
          width: 100%;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #f5f5f5;
          padding: 10px 0;
          margin-right: 0;
        }

        /deep/.el-checkbox__label {
          width: 100%;
          display: block !important;
          margin-right: 0;
        }

        .tab_bot_list_checkbox {
          font-size: 12px;
          color: #1aa689;

          .tab_bot_list_information {
            .tab_bot_list_information_run {
              margin-right: 8px;
              position: relative;
              cursor: pointer;

              &:hover::after {
                content: attr(data-tip);
                position: absolute;
                bottom: -18px;
                left: 50%;
                transform: translateX(-50%);
                background: rgba(0, 0, 0, 0.7);
                color: #fff;
                font-size: 10px;
                padding: 2px 6px;
                border-radius: 2px;
                white-space: nowrap;
                z-index: 999;
              }
            }
          }
        }
      }

      // 滚动条样式
      .tab_bot_list::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #f5f5f5;
      }

      .tab_bot_list::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background-color: #c1c1c1;
      }
    }
  }
}

// 地图容器
.map-container {
  width: 100%;
  height: 100%;
  margin-left: 280px;
  box-sizing: border-box;
  position: relative;
}

// 标记点加载提示
.map-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0,0,0,0.7);
  color: #fff;
  padding: 8px 16px;
  border-radius: 4px;
  z-index: 9999;
  font-size: 12px;
}

// 侧边收起时的地图样式
:deep(.recycler-map) {
  &:not(.tab-show) .map-container {
    margin-left: 30px;
  }
}

// 高德地图样式覆盖
/deep/.amap-marker {
  z-index: 999 !important;
}

/deep/.amap-marker-label {
  border: none;
}

/deep/.amap-info-window {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  border: none;
  z-index: 1001 !important;
}

// 修复图标加载样式
/deep/.amap-icon {
  background-size: contain !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
}
</style>